export default {
  install(Vue, { store }) {
    // store.registerModule("vtkVisualizer", require("./store"));
  }
};
